exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pos-loader{position: absolute;\r\n    left: 50%;\r\n    right: 50%;\r\n    top: 40%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    z-index: 9999;}\r\n\r\n.sk-spinner-wandering-cubes .sk-cube1, .sk-spinner-wandering-cubes .sk-cube2{background-color: #84ad05;\r\n    width: 28px;\r\n    height: 2px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/loader/loader.component.css
// module id = ../../../../../src/app/shared/loader/loader.component.css
// module chunks = main